import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { collectionToStories } from "@quintype/components";
import ImageType2 from "../../../../components/molecules/image-type-2";
import ImageType3 from "../../../../components/molecules/image-type-3";
import ImageType1 from "../../../../components/molecules/image-type-1";
import { SectionName } from "../../../../components/molecules/section-name";
import "./one-big-6-small.m.css";

const OneBigSixSmall = ({ collection }) => {
  const showSection = get(collection, ["associated-metadata", "show-section-title"], true);
  const bgColor = get(collection, ["associated-metadata", "Type bgColors for entire layout from (black, peach, yellow, violet)"]) || "yellow";
  const storiesFromCollection = collectionToStories(collection);
  if (storiesFromCollection.length < 1) {
    return null;
  }
  const [firstStory, ...restOftheStories] = storiesFromCollection || [];
  return (
    <React.Fragment>
      <div styleName={`wrapper ${bgColor}`} className="default-container">
        <div styleName="layout-container">
          <div styleName="container-wrapper">
          {showSection && (
              <div>
                <SectionName collection={collection} />
              </div>
            )}
            {<div styleName="big-img">
              <ImageType1 story={firstStory} showSubHeadline ={false}/>
            </div>}
            <div styleName="small-img-wrapper">
              {restOftheStories.length >= 1 &&
                restOftheStories.slice(0, 6).map((item, index) =>
                  <React.Fragment key={index}>
                    <div styleName="item" className="item" key={item.id}>
                      <div styleName="big-medium-screens">
                      <ImageType3 story={item} />
                      </div>
                      <div styleName="small-screens">
                      <ImageType2 story={item} />
                      </div>
                    </div>
                  </React.Fragment>
                )
              }
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
};

OneBigSixSmall.propTypes = {
  collection: object
};
export { OneBigSixSmall };

OneBigSixSmall.storyLimit = 22;
